import { render, staticRenderFns } from "./ProductSection.vue?vue&type=template&id=a96caab2&scoped=true"
import script from "./ProductSection.vue?vue&type=script&lang=js"
export * from "./ProductSection.vue?vue&type=script&lang=js"
import style0 from "./ProductSection.vue?vue&type=style&index=0&id=a96caab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96caab2",
  null
  
)

export default component.exports